"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var LogLevel = {
  DEBUG: 'debug',
  // least severity
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  CRITICAL: 'critical' // most severity

};
var _default = LogLevel;
exports.default = _default;